import { combineReducers } from 'redux';
import barcodes from './barcodes';
import barcodeTemplates from './barcodeTemplates';
import inventorySessions from './inventorySessions';
import bulkInventorySessions from './bulkInventorySessions'
import batchInventoryResults from './batchInventoryResults'
import products from './products';
import locations from './locations';
import prints from './prints';
import stores from './stores';
import payments from './payments';
import categories from './categories';
import brands from './brands';
import orderSessions from './orderSessions';
import pickOrder from './pickOrder';
import settings from './settings';
import incompleteOrders from './incompleteOrders';
import warehouseReceivingOrders from './warehouseReceivingOrders';
import warehouseAreas from './warehouseAreas';

export default combineReducers({
  barcodes,
  barcodeTemplates,
  inventorySessions,
  bulkInventorySessions,
  batchInventoryResults,
  products,
  locations,
  prints,
  stores,
  settings,
  categories,
  brands,
  payments,
  orderSessions,
  pickOrder,
  incompleteOrders,
  warehouseReceivingOrders,
  warehouseAreas,
});
